import classNames from "classnames";
import styles from "./DefectAreaOverlay.module.scss";

interface DefectAreaLegendProps {
  roiSize: number;
  marginSize: number;
}

const DefectAreaLegend = ({ roiSize, marginSize }: DefectAreaLegendProps) => (
  <div className={styles.legend}>
    <div className={styles.legendTitle}>What to classify</div>
    <div className={styles.legendRow}>
      <span className={classNames(styles.swatch, styles.swatchRoi)} />
      <div>
        <div className={styles.legendLabel}>Classification area</div>
        <div className={styles.legendText}>
          The pink marker ({roiSize.toLocaleString()} ×{" "}
          {roiSize.toLocaleString()} px) is the area to classify.
        </div>
      </div>
    </div>
    <div className={styles.legendRow}>
      <span className={classNames(styles.swatch, styles.swatchMargin)} />
      <div>
        <div className={styles.legendLabel}>Context</div>
        <div className={styles.legendText}>
          The dashed box ({marginSize.toLocaleString()} ×{" "}
          {marginSize.toLocaleString()} px from the center) is the context
          around the classification area. Use it to decide on the label.
        </div>
      </div>
    </div>
    <div className={styles.legendRow}>
      <span className={classNames(styles.swatch, styles.swatchContext)} />
      <div>
        <div className={styles.legendLabel}>Ignore</div>
        <div className={styles.legendText}>
          Anything in the dimmed area outside the context box is not relevant.
          Avoid using it when labeling.
        </div>
      </div>
    </div>
    <div className={styles.legendShortcuts}>
      <div>
        <kbd>H</kbd> Hold to hide all overlays
      </div>
      <div>
        <kbd>M</kbd> Turn the dimming on or off
      </div>
    </div>
  </div>
);

export default DefectAreaLegend;
